import React, { Component } from 'react';
import PropTypes from 'prop-types';

import debounce from 'lodash/debounce';
import classnames from 'classnames/bind';
import Icon from 'foundations/Icons/Icon';

import styles from './Filterable.css';
import breakpoints from 'styles/_breakpoints.css';

class Filterable extends Component {
  static propTypes = {
    customClasses: PropTypes.string,
    filters: PropTypes.arrayOf(PropTypes.object).isRequired,
    data: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.object).isRequired,
      PropTypes.arrayOf(PropTypes.string).isRequired,
    ]),
    placeholder: PropTypes.string,
    searchLabel: PropTypes.string,
    children: PropTypes.node,
    withoutSearch: PropTypes.bool
  };

  static defaultProps = {
    filters: [],
    searchLabel: 'Find'
  };

  state = {
    results: [],
    searchString: '',
    isSearching: false,
    searchResults: [],
    activeFilter: 'all',
    collapsedInput: false
  };

  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
    this.handleChangeSearch = this.handleChangeSearch.bind(this);
  }

  componentDidMount = () => {
    this.handleResize();

    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', this.handleResize);
  }

  handleMesureBreakpoint = () => window.innerWidth <= parseInt(breakpoints['desktop'].replace('px', ''));

  handleResize = () => {
    const { collapsedInput } = this.state;
    const insideBreakpoint = this.handleMesureBreakpoint();

    if (insideBreakpoint && !collapsedInput) {
      this.setState({ collapsedInput: true });
    } else if (!insideBreakpoint && collapsedInput) {
      this.setState({ collapsedInput: false });
    }
  }

  handleChangeSearch() {
    const searchString = this.searchInput.value;
    const currentResults = this.state.results.length ? this.state.results : this.props.data;

    this.handleSearch(searchString, currentResults);
  }

  handleSearch(searchString, filteredValues, options = {}) {
    const filteredResults = filteredValues.filter(item => {
      if (typeof item === 'object') {
        return item.name.indexOf(searchString) !== -1 || item.size.indexOf(searchString) !== -1;
      } else {
        return item.indexOf(searchString) !== -1;
      }
    });

    this.setState({
      searchResults: filteredResults,
      searchString,
      isSearching: searchString.length,
      ...options,
    });
  }

  handleClick(e) {
    const activeFilter = e.currentTarget.dataset.id || 'all';
    const { isSearching } = this.state;
    const { data } = this.props;
    const results = activeFilter === 'all'
      ? data
      : data.filter((elem) => elem.type === activeFilter)
    ;

    if (isSearching) {
      const { searchString } = this.state;

      const options = {
        results,
        activeFilter
      };

      this.handleSearch(searchString, results, options);
    } else {
      this.setState({ results, activeFilter });
    }
  }

  renderInput() {
    const { collapsedInput } = this.state;
    const { placeholder, searchLabel } = this.props;
    const delay = 300;

    return (
      <div className={classnames(styles.searchInput, 'flex flex-align-center')}>
        <Icon icon="search" type="20"/>
        <label className={classnames(styles.inputLabel, 'p large')} htmlFor="seachfield">{searchLabel}</label>
        <input
          id="seachfield"
          placeholder={collapsedInput ? `${searchLabel} ${placeholder}` : placeholder}
          type="text"
          ref={input => this.searchInput = input}
          onChange={debounce(this.handleChangeSearch, delay)}
          className={classnames('p large', styles.search)}
        />
      </div>
    );
  }

  renderSelection() {
    const { filters } = this.props;

    if (!filters.length) {
      return;
    }

    return (
      <ul className={styles.filterList}>
          {filters.map((filter, i) =>
            this.renderFilters(filter, i)
          )}
      </ul>
    );
  }

  renderFilters(filter, key) {
    const { activeFilter } = this.state;
    const cx = classnames.bind(styles);

    const classes = cx(
      'filters',
      {
        active: activeFilter === filter.key
      }
    );

    return (
      <li key={key} className={classnames('p small', classes)}>
        <a className={styles.link} data-id={filter.key} onClick={this.handleClick}>{filter.value}</a>
      </li>
    );
  }

  render() {
    const { children, data, customClasses, withoutSearch } = this.props;
    const { isSearching, searchResults, results } = this.state;
    const content = isSearching ? searchResults : results.length ? results : data;

    const childrenWithProps = React.cloneElement(children, { content });

    return (
      <div className={customClasses}>
        <div className={classnames(styles.flexDirection, styles.filterable, 'flex')}>
          {this.renderSelection()}
          {!withoutSearch && this.renderInput()}
        </div>
        {childrenWithProps}
      </div>
    );
  }
}

export default Filterable;



// WEBPACK FOOTER //
// ./src/components/Filterable/Filterable.js